import React, {useState} from 'react';
import styles from './Picker.module.scss';
import {config} from 'data/utils/constants';
import ImagePicker from 'react-image-picker';
import Arrows from './components/arrows';
import fill from 'fill-range';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';

interface IPickerProps {
  values?: any;
  submitCount?: any;
  errors?: any;
  setFieldValue?: any;
  size?: { width: number, height: number },
  placeKey?: string;
}

const width = 200;
const getNextImage = (currentShownPhotos, photos) => {
  const lastImage = currentShownPhotos[currentShownPhotos.length - 1];
  return photos[photos.indexOf(lastImage) + 1];
};
const getPrevImage = (currentShownPhotos, photos) => {
  const firstImage = currentShownPhotos[0];
  return photos[photos.indexOf(firstImage) - 1];
};
const brokenPng = "broken.png";
const referenceToImage = photo_reference => photo_reference.endsWith(brokenPng) ? photo_reference : `${config.api_server.placeImageUrl}/placephoto/${photo_reference}&maxwidth=400&341D4D3CDCE89B7428482D7DC4784`;

const imageToReference = (src, photos) => (photos
  .find(({photo_reference}) => referenceToImage(photo_reference) === src) || {}).photo_reference;
export const isNoImages = (photos) => {
  return photos.length === 1 && photos[0].photo_reference.endsWith(brokenPng);
};
const Picker = ({size, ...props}: IPickerProps) => {
  const width = size.width > 540 ? 200 : 100;
  if (props.values[props.placeKey].loading) {
    return (<div
      className={`${styles.image_picker} ${styles.skeletonsContainer}`}>
      {fill(1, Math.floor(size.width / width))
        .map(index => <SkeletonPlaceHolder
          key={index}
          className={styles.skeleton}
        />)
      }
    </div>);
  } else {
    const imagePick = props.values.imagePick;
    const photos = props.values[props.placeKey].photos || [];
    const [currentShownPhotos, setCurrentShownPhotos]: any = useState(photos.slice(0, size.width / width));
    const prevPhoto = getPrevImage(currentShownPhotos, photos);
    const nextPhoto = getNextImage(currentShownPhotos, photos);
    return (
      <>
        <ImagePicker
          className={`${styles.image_picker} ${(props.submitCount > 0 ? (props.errors['imagePick'] ? styles.error : styles.valid) : '')}`}
          images={currentShownPhotos.map(({photo_reference}) => {
              return ({
                src: referenceToImage(photo_reference),
                value: photo_reference,
                pickIndex: props.values.imagePick.indexOf(photo_reference) >= 0 ? (props.values.imagePick.indexOf(photo_reference) + 1) : undefined
              });
            }
          )}
          onPick={(pickedImages: { src: string, value: string, pickIndex: number }[]) => {
            /**
             * currently picked images from the currently shown images.
             */
            const pickedImagesValues = pickedImages
              .sort((image1, image2) => image1.pickIndex - image2.pickIndex)
              .map(({value}) => value);
            /**
             * Not picked images from the currently shown images, so need to remove them.
             */
            const removedImages = currentShownPhotos
              .map(({photo_reference}) => photo_reference)
              .filter(photo_reference => !pickedImagesValues.includes(photo_reference));

            return (props.setFieldValue('imagePick', [
              /**
               * Remove not picked images
               */
              ...imagePick.filter(photo_reference => !removedImages.includes(photo_reference)),
              /**
               * Prevent duplicates
               */
              ...pickedImagesValues.filter(photo_reference => !imagePick.includes(photo_reference)),
            ]));
          }
          }
          multiple
          CheckedComponent={props => {
            return (<span>{imagePick.indexOf(imageToReference(props.src, photos)) + 1}</span>)
          }
          }
        />
        <Arrows
          onLeftClick={() => {
            if (nextPhoto) {
              const c = [...currentShownPhotos];
              c.shift();
              c.push(nextPhoto);
              setCurrentShownPhotos(c);
            }
          }}
          onRightClick={() => {
            if (prevPhoto) {
              const c = [...currentShownPhotos];
              c.pop();
              c.unshift(prevPhoto);
              setCurrentShownPhotos(c);
            }
          }}
          hideRight={!prevPhoto}
          hideLeft={!nextPhoto}
        />
      </>
    );
  }
};

Picker.defaultProps =
  {
    //sizes: {width: width}
  };

export default React.memo(Picker);
